import { Steps } from 'antd';
const { Step } = Steps;

export const LCStep = Step;